// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsVerificationStatusesTemplate_heading__KmUFM"};